import { Action } from '../actions/spotters';

const defaultState = {
  isFetching: false,
  spottersByStationId: {},
  error: undefined,
};

export default function spottersReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case Action.Spotters.SpottersCompleted:
      return {
        isFetching: false,
        spottersByStationId: {
          ...state.spottersByStationId,
          [body.station_id]: body.spotters,
        },
      };

    case Action.Spotters.SpottersFailed:
      return {
        ...state,
        isFetching: false,
        error: body,
      };

    case Action.Spotters.SpottersPending:
      return {
        ...state,
        error: undefined,
        isFetching: true,
      };

    default:
      return state;
  }
}
